/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"home-page": require("./home-page.json"),
	"section-try-for-free": require("../../section-try-for-free/en/section-try-for-free.json"),
};
